import ButtonBack from '@/components/_common/ButtonBack';
import { SpedDocumentStatus } from '@/core/domain/sped/sped-documents/sped-documents.types';
import { Col, Row } from 'antd';
import SpedDocumentStartAnalysis from './SpedDocumentStartAnalysis';
import SpedDocumentCheckResults from './SpedDocumentCheckResults';
import SpedDocumentGenerateFiles from './SpedDocumentGenerateFiles';
import SpedDocumentCheckFiles from './SpedDocumentCheckFiles';
import SpedDocumentDownloadFiles from './spedDocumentDownloadFiles';
import { useSpedDocumentContext } from '@/pages/FiscalPages/SpedPage/SpedDocumentsPage/SpedDocumentDetailPage';
import SpeedDocumentReopen from './SpeedDocumentReopen';

export default function SpedDocumentFooter() {
  const spedDocument = useSpedDocumentContext();

  const startAnalysisEnabled =
    spedDocument?.status &&
    [
      SpedDocumentStatus.AWAITING_SELECTION,
      SpedDocumentStatus.REJECTED,
      SpedDocumentStatus.REOPENED,
    ].includes(spedDocument?.status);

  const checkResultsWithReopeningEnabled =
    spedDocument?.status &&
    [SpedDocumentStatus.ASSESSING, SpedDocumentStatus.REOPENING].includes(
      spedDocument?.status,
    );

  const generateFilesEnabled =
    spedDocument?.status &&
    [SpedDocumentStatus.ASSESSED].includes(spedDocument?.status);

  const checkFilesEnabled =
    spedDocument?.status &&
    [SpedDocumentStatus.GENERATING_FILE].includes(spedDocument?.status);

  const downloadFilesEnabled =
    spedDocument?.status &&
    [SpedDocumentStatus.COMPLETED].includes(spedDocument?.status);

  const reopenEnabled =
    spedDocument?.status &&
    [SpedDocumentStatus.COMPLETED].includes(spedDocument?.status);

  return (
    <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
      <Col>
        <ButtonBack path="/app/fiscal/sped" />
      </Col>

      {startAnalysisEnabled && (
        <Col>
          <SpedDocumentStartAnalysis />
        </Col>
      )}

      {checkResultsWithReopeningEnabled && (
        <Col>
          <SpedDocumentCheckResults />
        </Col>
      )}

      {generateFilesEnabled && (
        <Col>
          <SpedDocumentGenerateFiles />
        </Col>
      )}

      {checkFilesEnabled && (
        <Col>
          <SpedDocumentCheckFiles />
        </Col>
      )}

      {downloadFilesEnabled && (
        <Col>
          <SpedDocumentDownloadFiles />
        </Col>
      )}

      {reopenEnabled && (
        <Col>
          <SpeedDocumentReopen />
        </Col>
      )}
    </Row>
  );
}
